import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

interface VisibilityControlsProps {
  showAreas: boolean;
  setShowAreas: (show: boolean) => void;
  showRows: boolean;
  setShowRows: (show: boolean) => void;
  showPorts: boolean;
  setShowPorts: (show: boolean) => void;
}

export const VisibilityControls: React.FC<VisibilityControlsProps> = ({
  showAreas,
  setShowAreas,
  showRows,
  setShowRows,
  showPorts,
  setShowPorts,
}) => {
  const translate = useTranslate();
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={showAreas}
            onChange={(e) => setShowAreas(e.target.checked)}
            name="showAreas"
            color="secondary"
          />
        }
        label={translate('osfc.storage_ui.visibility.show_area_points')}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showRows}
            onChange={(e) => setShowRows(e.target.checked)}
            name="showRows"
            color="secondary"
          />
        }
        label={translate('osfc.storage_ui.visibility.show_row_points')}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showPorts}
            onChange={(e) => setShowPorts(e.target.checked)}
            name="showPorts"
            color="secondary"
          />
        }
        label={translate('osfc.storage_ui.visibility.show_port_points')}
      />
    </div>
  );
};
